const ENV = window['ENV'] || {};

export { ENV };
